module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      backgray: _vm.$route.path == '/conta/meus-planos'
    }
  }, [(_vm.showMenu) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "outside-section",
    class: {
      section:
        !_vm.showMenu &&
        _vm.$route.path != '/vale-pedagio' &&
        _vm.$route.path != '/valepedagio',
    },
    style: (_vm.window.document.webview ? ("min-height: " + (_vm.window.screen.height) + "px") : '')
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('app-footer')], 1) : _vm._e(), _vm._v(" "), _c('message-dialog'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "id": "loading-box-100"
    }
  }, [_c('div', {
    attrs: {
      "id": "loading-box-content-100"
    }
  }, [_c('svg', {
    staticClass: "loading-draw-svg",
    attrs: {
      "viewBox": _vm.markViewBox,
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "loading-draw-path",
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": _vm.markPath
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-5199ae0c!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/app.vue
// module id = 2125
// module chunks = 1